namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItem3ExemptForm {
        PmId: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PmGroupId: Serenity.StringEditor;
        PmExtCode: Serenity.StringEditor;
        PmDesc: Serenity.StringEditor;
        ListFg: Serenity.IntegerEditor;
        PluCode: Serenity.LookupEditor;
        StyleCode: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        SupplCode: Serenity.LookupEditor;
    }

    export class PsAdvPromoItem3ExemptForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoItem3Exempt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoItem3ExemptForm.init)  {
                PsAdvPromoItem3ExemptForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;

                Q.initFormType(PsAdvPromoItem3ExemptForm, [
                    'PmId', w0,
                    'PmType', w1,
                    'PmGroupId', w0,
                    'PmExtCode', w0,
                    'PmDesc', w0,
                    'ListFg', w1,
                    'PluCode', w2,
                    'StyleCode', w2,
                    'BrandCode', w2,
                    'CatCode', w2,
                    'SubCat1Code', w2,
                    'SubCat2Code', w2,
                    'SupplCode', w2
                ]);
            }
        }
    }
}
